import { LOCALE_UZ } from './locale.constants';

export const DEFAULT_LOCALE = LOCALE_UZ;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 20;
export const DEFAULT_LIMIT_10 = 10;
export const DEFAULT_LIMIT_100 = 100;

export const PROKURATURA_ORG_ID = '63d0fb220181794a44ddc649';
export const UZB_ID = '5d91e0abbc4c7dade230f681';

export const FILE_TYPE_EXCEL =
  'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const FILE_TYPE_EXCEL_XLS = 'application/vnd.ms-excel';
export const FILE_TYPE_EXCEL_XLSX =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const FILE_TYPE_PDF = '.pdf,application/pdf';
export const FILE_TYPE_DOC =
  '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const FILE_TYPE_XLS =
  '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const FILE_TYPE_DOC_PDF = `${FILE_TYPE_DOC},${FILE_TYPE_PDF}`;
export const FILE_TYPE_XLS_DOC_PDF = `${FILE_TYPE_XLS},${FILE_TYPE_DOC},${FILE_TYPE_PDF}`;

export const FILE_TYPE_JPG = '.jpg,jpeg,image/jpg,image/jpeg';
export const FILE_TYPE_PNG = '.png,image/png';
export const FILE_TYPE_GIF = '.gif,image/gif';

export const DEPARTMENT_ROOT_ID = 'root';
export const CURRENT_YEAR = Number(new Date().getFullYear().toString());
export const PREV_YEAR = CURRENT_YEAR - 1;
export const CURRENT_MONTH = (new Date().getMonth() + 1).toString().padStart(2, '0');
export const CURRENT_QUARTER = Math.floor((new Date().getMonth() + 3) / 3);

export const DASHBOARD_CHARTS_SCALES_TICKS_COLOR = '#ffffff';
